import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Josemaría Becerril Aceves</h1>
            </header>
            <div className="content">
                <p>Political scientist and anthropologist<br />
                Specialized in the ethnography of vulnerability, power and science & technology</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">My work</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
